export const DEFAULT_ERROR_MESSAGE =
  'Tivemos um problema ao adicionar seu produto ao carrinho. Por favor, recarregue a página e tente novamente.';
